<template>
  <div>
    <el-drawer
      :visible.sync="drawerShow"
      size="800px"
      :destroy-on-close="true"
      :wrapper-closable="true"
      :modal-append-to-body="false"
      :append-to-body="true"
      custom-class="todo-detail"
    >
      <div slot="title">
        <div class="flex align-items-center">
          <div v-if="type == 'equip_auth'" class="icon-item auth">
            <i class="iconfont icon-vesting" />
          </div>
          <div v-if="type == 'ap_recover'" class="icon-item recover">
            <i class="iconfont icon-call-request" />
          </div>
          <div v-if="type == 'income_order'" class="icon-item income">
            <i class="iconfont icon-order-delivery" />
          </div>
          <div class="ml mr">
            <span class="font-lg text-bold text-black">{{ info.title }}</span>
          </div>
          <el-tag v-if="info.status > 0" type="success" class="mt-xs">已处理</el-tag>
          <el-tag v-else type="danger" class="mt-xs">待处理</el-tag>
        </div>
      </div>
      <div v-loading="loading" class="content">
        <div v-if="type == 'equip_auth'" class="info-area">
          <div class="front-title mb">
            <span class="front-line">申请信息</span>
          </div>
          <div class="flex align-items-center desc-item">
            <div class="hd text-muted" style="width: 100px;">设备：</div>
            <div class="bd equip-title" @click="toEquipDetail(info.equipid)">{{ info.equip_name }}</div>
          </div>
          <div class="flex align-items-center desc-item">
            <div class="hd text-muted" style="width: 100px;">GO码：</div>
            <div class="bd equip-title" @click="toEquipDetail(info.equipid)">{{ info.go }}</div>
          </div>
          <div class="flex align-items-center desc-item">
            <div class="hd text-muted" style="width: 100px;">模型：</div>
            <div class="bd">{{ info.dev_name }}</div>
          </div>
          <div class="flex align-items-center desc-item">
            <div class="hd text-muted" style="width: 100px;">当前权限：</div>
            <div class="bd">{{ info.current_auth }}</div>
          </div>
          <div class="flex align-items-center desc-item">
            <div class="hd text-muted" style="width: 100px;">绑定时间：</div>
            <div class="bd">{{ info.bindtime | parseTime('{y}/{m}/{d}') }}</div>
          </div>

          <div v-if="info.apply_auth">
            <div class="front-title mb">
              <span class="front-line">留资信息</span>
            </div>
            <div class="flex align-items-center desc-item">
              <div class="hd text-muted" style="width: 100px;">申请权限：</div>
              <div class="bd">{{ info.apply_auth }}</div>
            </div>
            <div class="flex align-items-center desc-item">
              <div class="hd text-muted" style="width: 100px;">备注：</div>
              <div class="bd">{{ info.apply_remark ? info.apply_remark : "--" }}</div>
            </div>
          </div>

          <div v-if="info.status > 0">
            <div class="front-title mb">
              <span class="front-line">处理信息</span>
            </div>
            <div class="flex align-items-center desc-item">
              <div class="hd text-muted" style="width: 100px;">处理人：</div>
              <div class="bd">{{ info.operator }}</div>
            </div>
            <div class="flex align-items-center desc-item">
              <div class="hd text-muted" style="width: 100px;">时间：</div>
              <div class="bd">{{ info.updatetime | parseTime('{y}/{m}/{d} {h}:{i}') }}</div>
            </div>
            <div class="flex align-items-center desc-item">
              <div class="hd text-muted" style="width: 100px;">操作：</div>
              <div class="bd">{{ info.tip }}</div>
            </div>
          </div>
        </div>
        <div v-if="type == 'ap_recover'" class="info-area">
          <div class="front-title mb">
            <span class="front-line">申请信息</span>
          </div>
          <div class="flex align-items-center desc-item">
            <div class="hd text-muted" style="width: 100px;">设备：</div>
            <div class="bd equip-title" @click="toEquipDetail(info.equipid)">{{ info.equip_name }}</div>
          </div>
          <div class="flex align-items-center desc-item">
            <div class="hd text-muted" style="width: 100px;">GO码：</div>
            <div class="bd equip-title" @click="toEquipDetail(info.equipid)">{{ info.sim_go }}</div>
          </div>
          <div class="flex align-items-center desc-item">
            <div class="hd text-muted" style="width: 100px;">模型：</div>
            <div class="bd">{{ info.dev_name }}</div>
          </div>
          <div class="flex align-items-center desc-item">
            <div class="hd text-muted" style="width: 100px;">有效期：</div>
            <div class="bd">
              {{ info.expire_day | parseTime('{y}/{m}/{d}') }}
              <span v-if="expire_total" class="text-danger ml-xs">已过期{{ expire_total }}天</span>
            </div>
          </div>
          <div class="flex align-items-center desc-item">
            <div class="hd text-muted" style="width: 100px;">DTU型号：</div>
            <div class="bd">{{ info.dtuid ? info.dtu_model : '未知' }}</div>
          </div>
          <div class="flex align-items-center desc-item">
            <div class="hd text-muted" style="width: 100px;">物联卡号：</div>
            <div class="bd">
              {{ info.iccid }}
              <span v-if="info.sim_delete" class="text-danger ml-xs">已销户</span>
              <span v-else class="text-primary ml-xs">未销户</span>
            </div>
          </div>
          <div v-if="info.consult_param">
            <div class="front-title mb">
              <span class="front-line">留资信息</span>
            </div>
            <div class="flex align-items-center desc-item">
              <div class="hd text-muted" style="width: 100px;">称呼：</div>
              <div class="bd">{{ info.consult_param.name }}</div>
            </div>
            <div class="flex align-items-center desc-item">
              <div class="hd text-muted" style="width: 100px;">手机：</div>
              <div class="bd">{{ info.consult_param.mobile }}</div>
            </div>
            <div class="flex align-items-center desc-item">
              <div class="hd text-muted" style="width: 100px;">描述：</div>
              <div class="bd">{{ info.consult_param.description }}</div>
            </div>
          </div>

          <div v-if="info.status > 0">
            <div class="front-title mb">
              <span class="front-line">处理信息</span>
              <el-button type="text" @click="reHandle">重新处理</el-button>
            </div>
            <div class="flex align-items-center desc-item">
              <div class="hd text-muted" style="width: 100px;">处理人：</div>
              <div class="bd">{{ info.operator_name }}</div>
            </div>
            <div class="flex align-items-center desc-item">
              <div class="hd text-muted" style="width: 100px;">时间：</div>
              <div class="bd">{{ info.updatetime | parseTime('{y}/{m}/{d} {h}:{i}') }}</div>
            </div>
            <div class="flex align-items-center desc-item">
              <div class="hd text-muted" style="width: 100px;">备注：</div>
              <div class="bd">{{ info.god_remark }}</div>
            </div>
          </div>
        </div>
        <div v-if="type == 'income_order'" class="info-area">
          <div class="front-title mb">
            <span class="front-line">订单信息</span>
          </div>
          <div class="flex align-items-center desc-item">
            <div class="hd text-muted" style="width: 100px;">商品：</div>
            <div class="bd">{{ info.product_title }}</div>
          </div>
          <div class="flex align-items-center desc-item">
            <div class="hd text-muted" style="width: 100px;">属性：</div>
            <div class="bd">{{ info.product_attr }}</div>
          </div>
          <div class="flex align-items-center desc-item">
            <div class="hd text-muted" style="width: 100px;">数量：</div>
            <div class="bd">{{ info.total_num }}</div>
          </div>
          <div class="flex align-items-center desc-item">
            <div class="hd text-muted" style="width: 100px;">实付金额：</div>
            <div class="bd">￥{{ info.total_payed }}</div>
          </div>
          <div class="flex align-items-center desc-item">
            <div class="hd text-muted" style="width: 100px;">支付时间：</div>
            <div class="bd">{{ info.paytime | parseTime('{y}/{m}/{d} {h}:{i}') }}</div>
          </div>

          <div v-if="info.shipping_info">
            <div class="front-title mb">
              <span class="front-line">收货信息</span>
            </div>
            <div class="flex align-items-center desc-item">
              <div class="hd text-muted" style="width: 100px;">收货地址：</div>
              <div class="bd">{{ addr }}</div>
            </div>
            <div class="flex align-items-center desc-item">
              <div class="hd text-muted" style="width: 100px;">收件人：</div>
              <div class="bd">{{ info.shipping_info.contact_man }}</div>
            </div>
            <div class="flex align-items-center desc-item">
              <div class="hd text-muted" style="width: 100px;">联系电话：</div>
              <div class="bd">{{ info.shipping_info.contact_num }}</div>
            </div>
            <div class="flex align-items-center desc-item">
              <div class="hd text-muted" style="width: 100px;">备注：</div>
              <div class="bd">{{ info.remark ? info.remark : "--" }}</div>
            </div>
          </div>

          <div v-if="info.status > 0">
            <div class="front-title mb">
              <span class="front-line">发货信息</span>
            </div>
            <div class="flex align-items-center desc-item">
              <div class="hd text-muted" style="width: 100px;">处理人：</div>
              <div class="bd">{{ info.operator }}</div>
            </div>
            <div class="flex align-items-center desc-item">
              <div class="hd text-muted" style="width: 100px;">时间：</div>
              <div class="bd">{{ info.updatetime | parseTime('{y}/{m}/{d} {h}:{i}') }}</div>
            </div>
            <div class="flex align-items-center desc-item">
              <div class="hd text-muted" style="width: 100px;">物流信息：</div>
              <div class="bd">
                <span class="hd">{{ info.delivery_info.express_name }}</span>
                <span class="pl-sm bd">{{ info.delivery_info.express_sn }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="info.status == 0" class="drawer__footer flex-center">
          <el-button v-if="type == 'equip_auth'" type="danger" @click="handleReject()" plain>拒绝</el-button>
          <el-button v-else type="default" @click="close()" plain>关闭</el-button>
          <el-button type="primary" @click="openDialog()">处理</el-button>
        </div>
        <div v-else-if="info.status > 0" class="drawer__footer flex-center">
          <el-button type="default" @click="close()" plain>关闭</el-button>
        </div>
      </div>
    </el-drawer>
    <el-dialog
      width="600px"
      class="deal-dialog"
      :title="type == 'equip_auth' ? '提权申请' : type == 'ap_recover' ? '复机处理' : '发货处理'"
      :visible.sync="dialogShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div style="margin-top: 100px;">
        <el-form ref="form" :model="formData" label-position="left" label-width="100px" :rules="rules">
          <el-form-item v-if="type == 'equip_auth'" label="用户权限" prop="auth_level">
            <el-select v-model="formData.auth_level" clearable placeholder="选择权限" style="width: 100%;" @change="handleSelect">
              <el-option v-for="item in authArr" v-if="item.value" :key="item.value" :label="item.title" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item v-if="type == 'ap_recover'" label="备注" prop="god_remark">
            <el-input type="textarea" :rows="5" v-model="formData.god_remark" maxlength="200" show-word-limit />
          </el-form-item>
          <el-form-item v-if="type == 'income_order'" label="快递公司" prop="express_name">
            <el-input v-model="formData.express_name" autocomplete="off" clearable style="width: 100%"></el-input>
          </el-form-item>
          <el-form-item v-if="type == 'income_order'" label="快递单号" prop="express_sn">
            <el-input v-model="formData.express_sn" autocomplete="off" clearable style="width: 100%"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="flex-center">
        <el-button @click="dialogShow = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirm()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import {
  godAuthGetApi,
  godTodoRecoverGetApi,
  godTodoOrderGetApi,
  godTodoAuthPost,
  godTodoShopShipping,
  godTodoRecoverPost,
} from "@/api/common/todoApi.js";
export default {
  name: "TodoDetail",
  props: {
    show: {
      type: Boolean,
      default: false,
    },

    tdid: {
      type: [String, Number],
      default: null,
    },

    type: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      loading: false,

      info: {
        shipping_info: {},
      },
      expire_total: 0,
      addr: "", // 收货地址
      dialogShow: false,
      formData: {
        auth_level: null,
        express_name: "",
        express_sn: "",
        god_remark: "",
      },
      rules: {
        express_name: [
          { required: true, message: "快递公司不能为空", trigger: "blur" },
        ],
        express_sn: [
          { required: true, message: "快递单号不能为空", trigger: "blur" },
        ],
        auth_level: [{ required: true, message: "权限不能为空", trigger: "blur"}]
      },
    };
  },

  computed: {
    drawerShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },

    authArr() {
      return this.$store.state.userStore.is_frippler
        ? this.$store.state.rmsStore.authArr
        : this.$store.state.rmsStore.authArr.slice(0, 6);
    },
  },

  watch: {
    tdid(newVal) {
      this.info = {
        shipping_info: {},
      }
    },
    drawerShow(newVal) {
      if (newVal) {
        this.fetchData();
      }
    }
  },

  created() {
    // this.fetchData();
  },

  methods: {
    fetchData() {
      this.loading = true;
      const api =
        this.type == "ap_recover"
          ? godTodoRecoverGetApi
          : this.type == "equip_auth"
          ? godAuthGetApi
          : godTodoOrderGetApi;
      api({
        tdid: this.tdid,
      }).then((res) => {
        this.loading = false;

        if (!res.errno) {
          this.info = Object.assign({}, res.data);
          if (this.type == "ap_recover") {
            const now = Math.floor(Date.now() / 1000);
            if (res.data.expire_day && res.data.expire_day < now) {
              this.expire_total = Math.floor(
                (now - res.data.expire_day) / 86400
              );
            } else {
              this.expire_total = 0;
            }
          }
          if (this.type == "income_order") {
            this.addr = Object.values(res.data.shipping_info.address)
              .join(" ")
              .replace(/ /g, "");
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },

    openDialog() {
      this.dialogShow = true;
      if (this.$refs.form) this.$refs.form.resetFields();
    },

    handleSelect() {
      this.$nextTick(() => {
        this.$refs["form"].validateField("auth_level");
      });
    },
    handleReject() {
      this.$confirm("确认拒绝该请求？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        godTodoAuthPost({ tdid: this.tdid, operate_type: "refuse" }).then(
          (res) => {
            if (!res.errno) {
              this.$message.success("操作成功");
              this.fetchData();
              this.dialogShow = false;
              this.$emit("change");
            } else {
              this.$message.error(res.message);
            }
          }
        );
      });
    },
    reHandle() {
      this.$confirm("确认重新处理该请求？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        godTodoRecoverPost({tdid: this.tdid, status: 0, god_remark: this.formData.god_remark}).then(res => {
          if (!res.errno) {
            this.$message.success("操作成功");
            this.fetchData();
            this.$emit("change");
          } else {
            this.$message.error(res.message);
          }
        })
      })
    },
    close() {
      this.drawerShow = false;
      this.formData = {
        auth_level: null,
        express_name: "",
        express_sn: "",
        god_remark: "",
      };
      this.info = {};
      //   this.$emit("change");
    },
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const commitApi =
            this.type == "ap_recover"
              ? godTodoRecoverPost
              : this.type == "equip_auth"
              ? godTodoAuthPost
              : godTodoShopShipping;
          let params = {};
          if (this.type == "equip_auth") {
            params = {
              tdid: this.tdid,
              operate_type: "member_auth",
              auth_level: this.formData.auth_level,
            };
          } else if (this.type == "income_order") {
            params = {
              tdid: this.tdid,
              express_name: this.formData.express_name,
              express_sn: this.formData.express_sn,
            };
          } else if (this.type == "ap_recover") {
            params = {
              tdid: this.tdid,
              god_remark: this.formData.god_remark,
              status: 1,
            };
          }
          commitApi(params).then((res) => {
            if (!res.errno) {
              this.$message.success("操作成功");
              this.fetchData();
              this.dialogShow = false;
              this.$emit("change");
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    toEquipDetail(id) {
      this.$detail({type:'equip',id})
    },
  },
};
</script>
  
<style lang="scss" scoped>
/deep/ .el-drawer__header {
  margin-bottom: 0;
  padding-bottom: 15px;
  border-bottom: 1px solid #ebeef5;
}
.todo-detail {
  .icon-item {
    width: 40px;
    height: 40px;
    line-height: 40px;
    border-radius: 50%;
    text-align: center;
    color: #fff;
    font-size: 40px;
    &.auth {
      color: #07c160;
    }
    &.recover {
      color: #409eff;
    }
    &.income {
      color: #e6a23c;
    }
    &.grey {
      background-color: #909399;
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    height: 100%;
    .info-area {
      flex: 1;
      margin: 20px 30px;
      .front-title {
        height: 40px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .desc-item {
        min-height: 35px;
        margin-bottom: 10px;
      }
    }
    .drawer__footer {
      border-top: 1px solid #ebeef5;
      height: 60px;
    }
  }
  .equip-title {
    cursor: pointer;
    &:hover {
      color: #07c160;
    }
  }
}
/deep/.deal-dialog {
  .el-dialog__body {
    height: 350px;
    padding-left: 70px;
    padding-right: 70px;
  }
}
</style>
  